
import RcDomainMap from "../../common/RcDomainMap.js";
import Credentials from './Credentials.js';

export default class CredentialsMap extends RcDomainMap {
  static MODEL_NAME = "Credentials"  + "Map";
  
  constructor(domain, data) {
    super(domain, data, CredentialsMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new CredentialsMap(this.domain, data);
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getCredentials(key);
      values.push(item);
    }
    return values;
  }

  find() {
    var keys = this.keys();
    var found = new CredentialsMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.credentials().findById(key);
      var item = new Credentials(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    return found;
  }

  getCredentials(key) {
    var value = super.get(key);
    return new Credentials(this.domain, value);
  }
}